import React from 'react';
import { useDrop } from 'react-dnd';
import classnames from 'classnames';

const DropZone = ({ allowedItems, onDrop, canDrop: canDropExt, children, className }) => {
  const [{ canDrop, isOver, dragType }, drop] = useDrop({
    accept: allowedItems,
    drop: (item, monitor) => {
      onDrop && onDrop(item);
    },
    canDrop: (item, monitor) => {
      return typeof canDropExt === 'undefined' ? true : canDropExt(item);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      dragType: monitor.getItemType && monitor.getItemType(),
    }),
  });

  const isDragActive = isOver && canDrop;

  // Expand the effective drop hit area slightly using an invisible overlay.
  // This makes it easier to drop when the pointer is near the target, not exactly on it.
  const isCompatibleDrag = Array.isArray(allowedItems)
    ? allowedItems.includes(dragType)
    : allowedItems === dragType;

  return (
    <div className={className} style={{ position: 'relative' }}>
      <div
        ref={drop}
        style={{
          position: 'absolute',
          top: -12,
          right: -12,
          bottom: -12,
          left: -12,
          // Only capture pointer events while a compatible drag is occurring
          pointerEvents: isCompatibleDrag ? 'auto' : 'none',
          // Keep overlay invisible but above content to capture the drop
          background: 'transparent',
          zIndex: 1,
        }}
      />
      {React.cloneElement(children, {
        className: classnames(
          {
            drag: canDrop,
            'drag-over': isDragActive,
          },
          children.props.className,
        ),
      })}
    </div>
  );
};

export default DropZone;
